export default {
    'ERROR-GET-PUBLIC-SIGN-UP-HELPEE-DATA-FORM-IMPORT': {
        'UUID-NOT-VALID': {
            actionType: 'redirect',
            message: {
                fr: "Une erreur est survenue lors de la récupération des données",
                en: 'An error occurred while retrieving the data',
            },
            redirectPath: '/',
        },
        'CAMPAIGN-HELPEE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Une erreur est survenue lors de la récupération des données",
                en: 'An error occurred while retrieving the data',
            },
            redirectPath: '/',
        },
        'CAMPAIGN-ARCHIVED': {
            actionType: 'redirect',
            message: {
                fr: "Une erreur est survenue lors de la récupération des données",
                en: 'An error occurred while retrieving the data',
            },
            redirectPath: '/',
        },
        'CAMPAIGN-NOT-LAUNCHED': {
            actionType: 'redirect',
            message: {
                fr: "Une erreur est survenue lors de la récupération des données",
                en: 'An error occurred while retrieving the data',
            },
            redirectPath: '/',
        },
        'ORGANIZATION-ARCHIVED': {
            actionType: 'redirect',
            message: {
                fr: "Une erreur est survenue lors de la récupération des données",
                en: 'An error occurred while retrieving the data',
            },
            redirectPath: '/',
        },
        'CAMPAIGN-HELPEE-STATUS-INCORRECT': {
            actionType: 'redirect',
            message: {
                fr: "Une erreur est survenue lors de la récupération des données",
                en: 'An error occurred while retrieving the data',
            },
            redirectPath: '/',
        },
    },
};
